var CardImgList = function () {

	this.init = function () {
		$('[data-component="card-img-list"] .card-img-slick').slick({
			dots: false,
			slidesToShow: 4,
			infinite: false,
			arrows: false,
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						dots: true
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						dots: true
					}
				}
			]
		});
	}

	return this.init();
}
